"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShadePicker = void 0;
var _presentationHttp = require("@ori/presentation-http");
var _shadePicker = require("@ori/shade-picker");
var _tsUtils = require("@ori/ts-utils");
var _jsxRuntime = require("react/jsx-runtime");
const ShadePicker = () => {
  const {
    atpClusterId,
    customerTypeId
  } = (0, _presentationHttp.useUserSegmentationData)();
  return (0, _tsUtils.isNonNullable)(atpClusterId) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_shadePicker.ShadePickerController, {
    atpClusterId: atpClusterId,
    customerTypeId: customerTypeId
  }) : null;
};
exports.ShadePicker = ShadePicker;
